import { render, staticRenderFns } from "./choix-prestations.html?vue&type=template&id=13ee78c1&scoped=true&external"
import script from "./choix-prestations.js?vue&type=script&lang=js&external"
export * from "./choix-prestations.js?vue&type=script&lang=js&external"
import style0 from "./choix-prestations.scss?vue&type=style&index=0&id=13ee78c1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee78c1",
  null
  
)

export default component.exports